import React from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Spin } from "antd";
import VisualitzacioContainerTaulaMapa from "./VisualitzacioContainerTaulaMapa";
import VisualitzacioContainerMenu from "./VisualitzacioContainerMenu";
import VisualitzacioMenuLateral from "./VisualitzacioMenuLateral";
import {
  switchVisibilitatMenu,
  setTitolApartat,
  obtenirDadesUsuariPerIdObservador
} from "../../actions";
import {
  getPeticioVisualitzacioEnCurs,
  getVisibilitatMenu,
  getUsuari
} from "../../reducers";
import {
  MISSATGE_SPIN_VISUALITZACIO,
  TITOL_VISUALITZACIO
} from "../../constantsFormularis";
import { rutaLogin } from "../../routes";
import { calFerLogin, senseRols, tokenDecoded } from "../../utils/usuariRols";
import { LOCAL_STORAGE_USER } from "../../constantsObservacions";

class Visualitzacio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewPanell: true
    };
  }

  componentDidMount() {
    this.recuperarUsuari(this.props.usuari);
    this.props.setTitolApartat(TITOL_VISUALITZACIO);
  }

  recuperarUsuari = usuari => {
    if (!usuari || !usuari.id) {
      this.props.obtenirDadesUsuariPerIdObservador();
    }
  };

  handleOnClickDesplegarPlegarMenu = () => {
    const { switchVisibilitatMenu } = this.props;
    switchVisibilitatMenu();
  };

  recuperarUsuariRender = usuari => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    if (!token) {
      return <Redirect to={rutaLogin} />;
    }
    if (!calFerLogin(usuari)) {
      return this.tokenTrobatRender(usuari);
    } else {
      return this.tokenTrobatRender(tokenDecoded(token.token));
    }
  };

  tokenTrobatRender = usuari => {
    const { isPeticioEnCurs, visibilitatMenu } = this.props;

    if (senseRols(usuari)) {
      return <Redirect to={rutaLogin} />;
    }

    return (
      <Spin
        spinning={isPeticioEnCurs}
        tip={MISSATGE_SPIN_VISUALITZACIO}
        delay={300}
      >
        <VisualitzacioContainerMenu
          plegat={!visibilitatMenu}
          onClickPlegarDesplegar={this.handleOnClickDesplegarPlegarMenu}
        >
          <VisualitzacioMenuLateral />
        </VisualitzacioContainerMenu>
        <VisualitzacioContainerTaulaMapa />
      </Spin>
    );
  };

  render() {
    return this.recuperarUsuariRender(this.props.usuari);
  }
}

Visualitzacio.propTypes = {
  isPeticioEnCurs: PropTypes.bool,
  visibilitatMenu: PropTypes.bool,
  setTitolApartat: PropTypes.func.isRequired,
  usuari: PropTypes.object,
  obtenirDadesUsuariPerIdObservador: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    isPeticioEnCurs: getPeticioVisualitzacioEnCurs(state),
    visibilitatMenu: getVisibilitatMenu(state),
    usuari: getUsuari(state)
  };
};

const mapDispatchToProps = {
  switchVisibilitatMenu,
  setTitolApartat,
  obtenirDadesUsuariPerIdObservador
};

export default connect(mapStateToProps, mapDispatchToProps)(Visualitzacio);
